/* Fraktskydd – lägger till / tar bort fraktskydd-produkten i varukorgen */
(() => {
  if (window.__spInit) return;
  window.__spInit = true;

  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const url = (key) => `${window.routes[key]}.js`;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  // Uppdaterar varukorgs-draweren utan att öppna den (som Dawns renderContents, men tyst)
  function applySections(sections) {
    const drawerHtml = sections && sections['cart-drawer'];
    const drawer = document.querySelector('cart-drawer');
    if (drawerHtml && drawer) {
      const target = drawer.querySelector('#CartDrawer');
      const fresh = parse(drawerHtml).querySelector('#CartDrawer');
      if (target && fresh) {
        target.innerHTML = fresh.innerHTML;
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
      }
    }
    const bubbleHtml = sections && sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      const fresh = parse(bubbleHtml).querySelector('.shopify-section');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }
  }

  async function post(endpoint, body) {
    const res = await fetch(url(endpoint), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: window.location.pathname }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  }

  async function setProtection(variantId, on) {
    const data = on
      ? await post('cart_add_url', { items: [{ id: Number(variantId), quantity: 1 }] })
      : await post('cart_change_url', { id: String(variantId), quantity: 0 });
    applySections(data.sections);
  }

  document.addEventListener('change', async (event) => {
    const input = event.target.closest && event.target.closest('[data-sp-toggle]');
    if (!input) return;
    const box = input.closest('[data-sp-box]');
    const variantId = box && box.dataset.spVariant;
    if (!variantId) return;
    input.disabled = true;
    try {
      await setProtection(variantId, input.checked);
    } catch (e) {
      input.checked = !input.checked;
      input.disabled = false;
    }
  });

  // Om bara fraktskyddet finns kvar i varukorgen (kunden tog bort allt annat) – ta bort det också
  let cleaning = false;
  async function cleanOrphan() {
    if (cleaning) return;
    const marker = document.querySelector('[data-sp-orphan]');
    if (!marker) return;
    cleaning = true;
    try {
      await setProtection(marker.dataset.spOrphan, false);
    } catch (e) {
      /* ignore */
    }
    cleaning = false;
  }
  new MutationObserver(cleanOrphan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', cleanOrphan);
})();